/* Embla product rows: continuous gestures, fixed DOM, no product requests. */
(function () {
  'use strict';
  if (!window.EmblaCarousel || !window.IntersectionObserver || !window.ResizeObserver) return;
  var selector = '[data-spike-carousel]';
  var instances = new Map();
  var pending = new Set();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var number = function (value) { return Math.max(1, Number(value) || 1); };

  function initialize(root) {
    if (instances.has(root) || !root.isConnected) return;
    var config = JSON.parse(root.dataset.spikeCarousel);
    var viewport = root.querySelector('.spike-carousel__viewport');
    var track = root.querySelector('.spike-carousel__track');
    var slides = Array.from(track.children);
    if (!slides.length) return;
    var previous = root.querySelector('.slick-prev');
    var next = root.querySelector('.slick-next');
    var dots = root.querySelector('.slick-dots');
    var section = root.closest('.trending-product');
    var counter = section && section.querySelector('.slider-counter');
    var title = section && section.querySelector('.section-header .title');
    var timer, visible = false, hovered = false, focused = false, dragging = false;
    var listeners = [];
    function listen(node, event, callback, options) {
      node.addEventListener(event, callback, options);
      listeners.push(function () { node.removeEventListener(event, callback, options); });
    }

    // Keep browser zoom native. The wheel plugin otherwise treats Ctrl+wheel
    // as a drag; stopping propagation here does not cancel the default action.
    listen(viewport, 'wheel', function (event) {
      if (event.ctrlKey || event.metaKey || event.altKey) {
        event.stopImmediatePropagation();
      } else if (event.shiftKey && !event.deltaX && event.deltaY) {
        event.preventDefault();
        event.stopImmediatePropagation();
        viewport.dispatchEvent(new WheelEvent('wheel', {
          deltaX: event.deltaY, deltaMode: event.deltaMode,
          clientX: event.clientX, clientY: event.clientY, bubbles: true, cancelable: true
        }));
      }
    }, { capture: true, passive: false });
    var plugins = window.EmblaCarouselWheelGestures ? [window.EmblaCarouselWheelGestures({
      breakpoints: { '(hover: none)': { active: false } }
    })] : [];
    var api = window.EmblaCarousel(viewport, {
      align: 'start', loop: !!config.loop, dragFree: true, skipSnaps: true,
      duration: 25, direction: config.rtl ? 'rtl' : 'ltr',
      slidesToScroll: number(config.step), watchSlides: false,
      watchDrag: function (_, event) {
        return !event.target.closest('button, input, select, textarea, [data-quickview], [data-wishlist], [data-quickshop-popup]');
      },
      breakpoints: {
        '(max-width: 1199px)': { slidesToScroll: number(config.stepTablet) },
        '(max-width: 767px)': { slidesToScroll: number(config.stepMobile) },
        '(prefers-reduced-motion: reduce)': { duration: 0 }
      }
    }, plugins);
    root.spikeCarousel = api;
    root.classList.add('spike-carousel-initialized');
    viewport.tabIndex = 0;
    if (title) viewport.setAttribute('aria-label', title.textContent.trim());
    viewport.setAttribute('role', 'region');
    slides.forEach(function (slide, index) {
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-label', (index + 1) + ' / ' + slides.length);
    });

    function stopAutoplay() { clearTimeout(timer); }
    function scheduleAutoplay() {
      stopAutoplay();
      if (!config.autoplay || reduced.matches || !visible || hovered || focused || dragging || document.hidden ||
          document.body.matches('.spike-nav-open, .spike-mobilemenu-open, .newsletter-show, .newsletter-message-show')) return;
      if (!api.canScrollNext() && !api.canScrollPrev()) return;
      timer = setTimeout(function () { api.scrollNext(); }, Math.max(1000, Number(config.autoplaySpeed) || 5000));
    }
    function updateAccessibility() {
      var inView = api.slidesInView();
      slides.forEach(function (slide, index) {
        var offscreen = !inView.includes(index) && !slide.contains(document.activeElement);
        slide.inert = offscreen;
        slide.setAttribute('aria-hidden', String(offscreen));
      });
    }
    function update() {
      var mobile = window.matchMedia('(max-width: 1199px)').matches;
      var count = api.scrollSnapList().length;
      var index = api.selectedScrollSnap();
      var scrollable = api.canScrollNext() || api.canScrollPrev();
      previous.hidden = next.hidden = !scrollable || !(mobile ? config.arrowsMobile : config.arrows);
      previous.disabled = !api.canScrollPrev();
      next.disabled = !api.canScrollNext();
      previous.classList.toggle('slick-disabled', previous.disabled);
      next.classList.toggle('slick-disabled', next.disabled);
      dots.hidden = !scrollable || !(mobile ? config.dotsMobile : config.dots);
      if (dots.children.length !== count) {
        dots.replaceChildren();
        for (var i = 0; i < count; i++) {
          var item = document.createElement('li');
          var button = document.createElement('button');
          button.type = 'button';
          button.dataset.slide = i;
          button.setAttribute('aria-label', (i + 1) + ' / ' + count);
          item.appendChild(button);
          dots.appendChild(item);
        }
      }
      Array.from(dots.children).forEach(function (item, i) {
        item.classList.toggle('slick-active', i === index);
        item.firstChild.setAttribute('aria-current', String(i === index));
      });
      if (counter) {
        counter.hidden = !scrollable;
        counter.textContent = (index + 1) + '/' + count;
      }
    }
    listen(previous, 'click', function () { api.scrollPrev(); });
    listen(next, 'click', function () { api.scrollNext(); });
    listen(dots, 'click', function (event) {
      var button = event.target.closest('button[data-slide]');
      if (button) api.scrollTo(Number(button.dataset.slide));
    });
    listen(root, 'keydown', function (event) {
      if (event.target.closest('input, select, textarea') || event.altKey || event.ctrlKey || event.metaKey) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      var forward = (event.key === 'ArrowRight') !== !!config.rtl;
      api[forward ? 'scrollNext' : 'scrollPrev']();
    });
    listen(root, 'mouseenter', function () { hovered = true; stopAutoplay(); });
    listen(root, 'mouseleave', function () { hovered = false; scheduleAutoplay(); });
    listen(root, 'focusin', function () { focused = true; stopAutoplay(); });
    listen(root, 'focusout', function (event) { focused = root.contains(event.relatedTarget); scheduleAutoplay(); });
    api.on('pointerDown', function () { dragging = true; stopAutoplay(); });
    api.on('pointerUp', function () { dragging = false; });
    api.on('scroll', stopAutoplay);
    api.on('select', update);
    api.on('slidesInView', updateAccessibility);
    api.on('settle', function () { updateAccessibility(); scheduleAutoplay(); });
    api.on('reInit', function () { update(); updateAccessibility(); scheduleAutoplay(); });
    update();
    updateAccessibility();
    var visibility = new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      scheduleAutoplay();
    }, { threshold: 0.15 });
    if (config.autoplay) visibility.observe(root);
    instances.set(root, {
      schedule: scheduleAutoplay,
      destroy: function () {
        stopAutoplay();
        visibility.disconnect();
        listeners.forEach(function (remove) { remove(); });
        api.destroy();
        root.classList.remove('spike-carousel-initialized');
        slides.forEach(function (slide) { slide.inert = false; slide.removeAttribute('aria-hidden'); });
        delete root.spikeCarousel;
      }
    });
  }

  var observer = 'IntersectionObserver' in window && new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      pending.delete(entry.target);
      initialize(entry.target);
    });
  }, { rootMargin: '600px 0px' });
  function scan(scope) {
    scope.querySelectorAll(selector).forEach(function (root) {
      if (instances.has(root) || pending.has(root)) return;
      // Deferred homepage rows contain only a <noscript> placeholder until
      // their cards arrive. Scanning that placeholder freezes Embla at one slide.
      if (root.closest('[data-spike-deferred-home-row]')) return;
      if (observer) { pending.add(root); observer.observe(root); }
      else initialize(root);
    });
  }
  function scheduleAll() { instances.forEach(function (state) { state.schedule(); }); }
  document.addEventListener('visibilitychange', scheduleAll);
  reduced.addEventListener('change', scheduleAll);
  new MutationObserver(scheduleAll).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  window.spikeProductCarouselScan = scan;
  document.addEventListener('shopify:section:unload', function (event) {
    pending.forEach(function (root) {
      if (event.target.contains(root)) { observer.unobserve(root); pending.delete(root); }
    });
    instances.forEach(function (state, root) {
      if (event.target.contains(root)) { state.destroy(); instances.delete(root); }
    });
  });
  scan(document);
}());
